import {NewUserData} from "src/page/users/Users";
import {api} from "src/service/conf/axiosConf";

const url = "/api/users";

export const UserApi = {
    list: async function getAllUsers(): Promise<any> {
        const response = await api.get(`${url}/get_all_users?active=false&skip=0&limit=100`)
        return response.data;
    },

    get: async function getUser(): Promise<any> {
        const response = await api.get(url)
        return response.data;
    },

    post: async function createUser(): Promise<any> {
        const response = await api.post(url)
        return response.data;
    },

    put: async function updateUser(): Promise<any> {
        const response = await api.put(url)
        return response.data;
    },

    delete: async function deleteUser(id: string): Promise<any> {
        if (!id) {
            throw new Error("ID non valido");
        }
        const response = await api.delete(`${url}/deleteUser/${id}`);
        return response.data;
    },

    patch: async function updateUser(id: string, data: Partial<{ logged: boolean, passkey: string, is_active: boolean }>): Promise<any> {
        if (!id) throw new Error("ID non valido");
        const response = await api.patch(`${url}/updateUser/${id}`, data);
        return response.data;
    },

    putNewUser: async function createUser(userData: NewUserData): Promise<any> {
        const response = await api.put(`${url}/createUser`, userData);
        return response.data;
    },

}
